import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Form from './Form';
import AddressButtonContainer from './AddressButtonContainer';
import ProfileTitle from '../../../../layout/mobile/profile/ProfileTitle';

const useStyles = makeStyles(() => ({
  container: {
    border: '1px solid #BCBCBC',
    width: '100%',
    borderRadius: 10,
    padding: '30px 24px',
    marginBottom: 24,
  },
}));

const AddressForm = ({ ...props }) => {
  const classes = useStyles();
  const { mobile, title, subtitle, addresses, isBillAddress } = props;
  const [formVisible, setFormVisible] = useState(false);
  const [address, setAddress] = useState();

  const handleVisibleClick = () => {
    setAddress(undefined);
    setFormVisible(!formVisible);
  };

  const handleClickOnEditAddress = (address) => {
    setAddress(address);
    setFormVisible(!formVisible);
  };

  return (
    <Paper elevation={0} className={classes.container}>
      <ProfileTitle title={title} subtitle={subtitle} />
      {!formVisible && (
        <AddressButtonContainer
          addresses={addresses}
          onClick={handleVisibleClick}
          onClickEdit={handleClickOnEditAddress}
        />
      )}
      {formVisible && (
        <Form
          mobile={mobile}
          address={address}
          handleVisibleClick={handleVisibleClick}
          isBillAddress={isBillAddress}
        />
      )}
    </Paper>
  );
};

AddressForm.propTypes = {
  mobile: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  addresses: PropTypes.array,
  isBillAddress: PropTypes.bool,
};

export default AddressForm;
